/* eslint-disable no-nested-ternary */
import { twMerge } from 'tailwind-merge';
import { ExclamationCircleIcon } from '@heroicons/react/16/solid';

export function Timepicker({
  label,
  name,
  value = '12:00',
  isInvalid = false,
  validationMessage = '',
  startTime,
  endTime,
  onChange,
  optional,
  orientation = 'vertical',
  disabled = false,
  grid = false,
  ...props
}: {
  label?: string;
  name: string;
  value: string;
  startTime?: string;
  endTime?: string;
  isInvalid?: boolean;
  validationMessage?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  optional?: boolean;
  orientation?: 'vertical' | 'horizontal';
  disabled?: boolean;
  grid?: boolean;
}) {
  const isHorizontal = orientation === 'horizontal';

  return (
    <div
      className={twMerge(
        isHorizontal && grid
          ? 'flex flex-row items-center justify-between gap-2 w-full'
          : isHorizontal
          ? 'flex items-center space-x-4'
          : 'flex flex-col',
        label ? '' : 'justify-center mt-1'
      )}
    >
      {label && (
        <div className={isHorizontal ? 'flex flex-col' : 'flex items-center'}>
          <label
            htmlFor={name}
            className='block text-sm font-medium leading-5 font-inter text-gray-900'
          >
            {label}
          </label>
          {optional && (
            <span
              className={` text-sm leading-5 font-normal font-inter text-gray-400 ${
                isHorizontal ? '' : 'ml-2'
              }`}
            >
              Optional
            </span>
          )}
        </div>
      )}
      <div
        className={twMerge(
          'relative',
          label && !isHorizontal ? 'mt-2' : '',
          isHorizontal ? 'flex flex-col' : ''
        )}
      >
        <div className='relative'>
          <input
            id={name}
            name={name}
            type='time'
            value={value}
            onChange={onChange}
            min={startTime}
            max={endTime}
            disabled={disabled}
            {...props}
            className={twMerge(
              'block rounded-md bg-white py-1.5 pl-3 text-sm/6 border-gray-200 h-8',
              isInvalid
                ? 'text-red-900 outline-1 -outline-offset-1 outline-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 pr-10'
                : 'pr-3 px-3 py-1.5 text-gray-950 outline-1 -outline-offset-1 outline-gray-200 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-200',
              disabled
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed opacity-60'
                : ''
            )}
          />
          {isInvalid && (
            <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3'>
              <ExclamationCircleIcon
                aria-hidden='true'
                className='h-5 w-5 text-red-500'
              />
            </span>
          )}
        </div>
        {isInvalid && validationMessage && (
          <p id={`${name}-error`} className='mt-1 text-sm text-red-600'>
            {validationMessage}
          </p>
        )}
      </div>
    </div>
  );
}
